//#region src/compatibility/legacy-space-image-geometry-wire.ts
/** Project validated wire output only; canonical revisions retain geometry. */
function toLegacySpaceImageGeometryWireValue(value) {
	if (Array.isArray(value)) return value.map(toLegacySpaceImageGeometryWireValue);
	if (!value || typeof value !== "object" || Object.getPrototypeOf(value) !== Object.prototype) return value;
	const isFileRevision = "fileId" in value && "revision" in value && "mimeType" in value && "sizeBytes" in value;
	return Object.fromEntries(Object.entries(value).filter(([key]) => !isFileRevision || key !== "imageDimensions").map(([key, nested]) => [key, toLegacySpaceImageGeometryWireValue(nested)]));
}
//#endregion
export { toLegacySpaceImageGeometryWireValue };

//# sourceMappingURL=legacy-space-image-geometry-wire.js.map